import { AUTO, Game } from 'phaser';

import { Game as MainGame } from './scenes/Game';

const config: Phaser.Types.Core.GameConfig = {
  scene: [
    MainGame,
  ],
  parent: 'game-container',
  antialiasGL: false,
  transparent: true,
  height: '100%',
  width: '100%',
  type: AUTO
};

export const StartGame = (parent: string) => {
  return new Game({ ...config, parent });
};